import { useHistory } from 'react-router-dom';
import ZtServiceFactory from '@src/services/zt';
import qs from '@xfe-team/utils/src/query-string-util';
import { useEffect } from 'react';

class BaseStore {
  $history;
  /**
   * store中初始化service接口变量
   */
  $ztService = ZtServiceFactory.getDefaultInstance();

  $props;

  /**
   * 组织ID
   */
  // orgId = 'xishanju-test';
  orgId = DEPLOY_ENV === 'master' ? 'xishanju' : 'xishanju-test';
  /**
   * 跳转至具体的路由
   * @param {string} url - 跳转路由地址
   * @param {boolean} [isReplace] - 是否替换
   */
  redirect(url, isReplace = false) {
    if (isReplace) {
      this.$history.replace(url);
    } else {
      this.$history.push(url);
    }
  }

  aLink(url, target = '_blank') {
    const a = document.createElement('a');
    a.href = url;
    a.target = target;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  /**
   * 页面跳转
   */
  jumpPage(url, params = null, newStatus = false) {
    // let fullPath = window.location.origin + window.location.pathname;
    // let urlWithoutFileName = fullPath.replace(/\/[^\/]+\.html$/, '/');
    // // 如果路径末尾没有斜杠，则添加斜杠（可选）
    // if (!urlWithoutFileName.endsWith('/')) {
    //   urlWithoutFileName += '/';
    // }
    // let nextUrl = urlWithoutFileName + url;
    // if (params) {
    //   nextUrl += `${params}`;
    // }

    // if (newStatus) {
    //   aLink(nextUrl);
    // } else {
    //   window.location.href = nextUrl;
    // }
    let fullPath = window.location.origin + window.location.pathname;
    let urlWithoutFileName = fullPath.replace(/\/[^\/]+\.html$/, '/');

    if (!urlWithoutFileName.endsWith('/')) {
      urlWithoutFileName += '/';
    }

    // 🔥 只获取浏览器 ? 开头的公共参数（utm_source 等）
    const search = window.location.search;

    // 拼接：基础路径 + 目标页面 + 公共参数 + 你自己的路由参数
    let nextUrl = urlWithoutFileName + url + search;
    if (params) {
      nextUrl = urlWithoutFileName + url + search + params;
    }

    // 跳转
    if (newStatus) {
      this.aLink(nextUrl);
    } else {
      window.location.href = nextUrl;
    }
  }
  // jumpPage(url, params = null, reloadStatus = false) {
  //   // 验证输入的 url 是否为有效字符串
  //   if (typeof url !== 'string' || url.trim() === '') {
  //     console.error('无效的 URL 参数');
  //     return;
  //   }
  //   try {
  //     // 获取当前页面的基础 URL
  //     const baseUrl = new URL(window.location.origin + window.location.pathname);
  //     // 移除文件名，获取目录路径
  //     baseUrl.pathname = baseUrl.pathname.replace(/\/[^\/]+\.html$/, '/');
  //     // 拼接目标 URL
  //     const nextUrl = new URL(url, baseUrl);
  //     // 如果有查询参数，添加到 URL 中
  //     if (params) {
  //       // nextUrl.search = params.startsWith('?') ? params.slice(1) : params;
  //       nextUrl.href += `${params}`;
  //     }

  //     // 执行页面跳转
  //     window.location.href = nextUrl.href;
  //     // 如果需要重新加载页面
  //     if (reloadStatus) {
  //       // window.location.reload();
  //       setTimeout(() => {
  //         reload();
  //       }, 100);
  //     }
  //   } catch (error) {
  //     console.error('页面跳转时发生错误:', error);
  //   }
  // }

  /**
   * 创建 search params 参数
   * @private
   */
  _createSearchParams() {
    let { search = '' } = this.$history.location;
    search = search.replace(/^\?/, '');
    useEffect(
      () => {
        if (search) {
          this.$searchParams = qs.parse(search);
        } else {
          this.$searchParams = {};
        }
      },
      [search]
    );
  }

  use(props) {
    this.$props = props || {};
    this.$history = useHistory();
    /**
     * 路由参数
     * @type {History}
     */
    // this.$routeParams = useParams();
    // this.$routeMatch = useRouteMatch();
    // this._createSearchParams();
  }
}

export default BaseStore;
